import React      from 'react';
import classNames from 'classnames';

import { staticPageConstants } from '../../../../../common/constants/staticPageConstants';

function renderTextBlock(data, index) {
  return (
    <section
      className={'text_block_container'}
      style={{ backgroundColor: data.BACKGROUND_COLOR }}
      key={index}
    >
      <div
        className={classNames('container', {
          'top':   data.TEXT_TYPE === staticPageConstants.COMPONENTS.TEXT_BLOCK.SETTINGS.TEXT_TYPE.HIGHLIGHTED_TEXT,
          'muted': data.TEXT_TYPE === staticPageConstants.COMPONENTS.TEXT_BLOCK.SETTINGS.TEXT_TYPE.MUTED_TEXT,
        })}
        dangerouslySetInnerHTML={{ __html: data.CONTENT }}
      />
    </section>

  );
}

export default renderTextBlock;